import React, { FC, ComponentProps } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { RangeDatePicker } from 'transfix-ui/components/RangeDatePicker'
import { formatDate } from 'apps/spot-quote-control-panel/utils/shipperStrikePrice'
import { IDatePickerProps } from 'transfix-ui'

type IBaseControllerProps = ControllerProps<React.ComponentType<IDatePickerProps>>
export interface IControlledRangeDatePickerProps
  extends Pick<IBaseControllerProps, 'control' | 'defaultValue' | 'name'> {
  RangeDatePickerProps?: Omit<
    ComponentProps<typeof RangeDatePicker>,
    'onDateChange' | 'dates' | 'minDate' | 'invalid' | 'validationMessage'
  >
  minDate: Date
  invalid?: boolean
  validationMessage?: string
}

const ControlledRangeDatePicker: FC<IControlledRangeDatePickerProps> = ({
  control,
  defaultValue,
  invalid,
  minDate,
  name,
  validationMessage,
  RangeDatePickerProps = {
    label: 'Select Date(s)',
    placeholder: 'Double click for single date',
    dateFormat: 'm-d-Y',
    required: true,
    large: true,
  },
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler = (dateArr: Date[]) => {
          const start = dateArr[0] ? formatDate(dateArr[0]) : undefined
          const end = dateArr[1] ? formatDate(dateArr[1]) : undefined
          onChange({
            rangeStart: start,
            rangeEnd: end,
          })
        }
        const dates = value ? [new Date(value.rangeStart), new Date(value.rangeEnd)] : []

        return (
          <RangeDatePicker
            minDate={minDate}
            dates={dates}
            onDateChange={changeHandler}
            invalid={invalid}
            validationMessage={validationMessage}
            {...RangeDatePickerProps}
          />
        )
      }}
    />
  )
}

export default ControlledRangeDatePicker
